export default {

    fr:{
        // Compte Expert Dashboard 12  je suis laaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa
        'Tableau de bord' : 'Tableau de bord',
        ' vient de valider la Proposition commerciale ':' vient de valider la Proposition commerciale ',
        'Compte ' :'Compte ',
        'Données profil' :'Données profil',
        'Documents administratifs' :'Documents administratifs',
        'Paramètres de compte' :'Paramètres de compte',
        'Messages' :'Messages',
        'Non disponible':'Non disponible',
        'Se déconnecter' :'Se déconnecter',
        'Appels d\'offres' :'Appels d\'offres',
        'Rechercher un AO' :'Rechercher un AO',
        'Mes candidatures' :'Mes candidatures',
        'Mes RDV' :'Mes RDV',
        'Mes favoris' :'Mes favoris',
        'Mes alertes' :'Mes alertes',
        'Missions et BDC' :'Missions et BDC',
        'Bons de commandes' :'Bons de commandes',
        'Mes missions' :'Mes missions',
        'CRA et Factures' :'CRA et Factures',
        'Compte rendu d\'activité' :'Compte rendu d\'activité',
        'Liste des CRA' :'Liste des CRA',
        'Factures' :'Factures',
        'Outil Suivi' :'Outil Suivi',
        'Total candidatures' :'Total candidatures',
        'Candidatures intéressantes' :'Candidatures intéressantes',
        'Entretiens' :'Entretiens',
        'Candidatures Retenues' :'Candidatures Retenues',
        'Candidatures par jour' :'Candidatures par jour',
        'Notifications' :'Notifications',
        'Notification' :'Notification',
        'Tâches à réaliser' :'Tâches à réaliser',
        'Total tâches' :'Total tâches',
        'Total ouvert' :'Total ouvert',
        'Ouvert':'Ouvert',
        'Les vues de profil' :'Les vues de profil',
        'Statut des candidatures par AO' :'Statut des candidatures par AO',
        'Rendez-vous à venir' :'Rendez-vous à venir',
        'Aucun rendez-vous pour le moment' :'Aucun rendez-vous pour le moment',
        'Rendez vous le' :'Rendez vous le',
    },
    en:{
        // Expert Account Dashboard 12
        'Tableau de bord' : 'Dashboard',
        'Compte ' : 'Account',
        'Données profil' : 'Profile',
        'Documents administratifs' : 'Administrative documents',
        'Paramètres de compte' : 'Account settings',
        'Messages' : 'Messages',
        'Se déconnecter' : 'Sign out',
        'Appels d\'offres' : 'Jobs',
        'Non disponible':'Not available',
        'Rechercher un AO' : 'Search Jobs',
        'Mes candidatures' : 'My applications',
        'Mes RDV' : 'My Appointments',
        'Mes alertes' : 'My alerts',
        'Missions et BDC' : 'Assignments and PO',
        'Bons de commandes' : 'Purchase Order',
        'Mes missions' : 'My Projects',
        'CRA et Factures' : 'Timesheets and invoices',
        'Compte rendu d\'activité' : 'Timesheet',
        'Liste des CRA' : 'Timesheet list',
        'Factures' : 'Invoices',
        // 'Outil suivi' : 'Tracking tool',
        'Total candidatures' : 'Total applications',
        'Candidatures intéressantes' : 'Interesting applications',
        'Entretiens' : 'Interviews',
        'Candidatures Retenues' : 'Selected applications',
        'Candidatures par jour' : 'Applications per day',
        'Tâches à réaliser' : 'Tasks to do',
        'Total tâches' : 'Total tasks',
        'Total ouvert' : 'Total open',
        'Notifications' : 'Notifications',
        'Notification' : 'Notification',
        'Les vues de profil' : 'profile views',
        'Statut des candidatures par AO' :'Application status per job',
        'Rendez-vous à venir' : 'Appointments to come/Futur appointments',
        'Aucun rendez-vous pour le moment' : 'No appointment for the moment',
        'Rendez vous le 09/09/2022 à 16 :00' : 'Appointment on 09/09/2022 at 4:00 pm',//#
    },
};